/**
 * @author      david.loehr@zumper.com (David Loehr)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { Box } from '@chakra-ui/react'
import { selectTourEntity } from '@zcode-ui/perm-address'
import type { AddressPageContextType } from '@zcode-ui/web-zumper-pages'
import { AnalyticsC } from '@zcode/nr-utils'
import React, { type ForwardedRef, forwardRef } from 'react'
import { type GetProps, useSelector } from 'react-redux'
import { MessageButtonContainer } from '../../components/MessageButton/MessageButtonContainer'

export const AddressMessageButton = forwardRef(
  (
    { boxProps, ...props }: GetProps<AddressPageContextType['MessageButton']>,
    ref: ForwardedRef<HTMLAnchorElement & HTMLButtonElement>
  ) => {
    const entity = useSelector(selectTourEntity)
    if (!entity?.isActive) {
      return null
    }
    const button = (
      <MessageButtonContainer
        analyticChannel={AnalyticsC.PERMANENT_ADDRESS}
        disableOneTap={entity.isSpecialtyHousing}
        ref={ref}
        showMessagedState={false}
        text="Check availability"
        variant="pink"
        {...props}
        entity={entity}
      />
    )
    if (boxProps) {
      return <Box<'div'> {...boxProps}>{button}</Box>
    }
    return button
  }
)
